import gql from 'graphql-tag';

export default fields => gql`
mutation ($input: CreateTaskInput!) {
    createTask (input: $input) {
        __typename
        ${[...['id', 'name'].concat(fields)]}
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/BacklogTasks/NewMutation.js